import { styled } from 'styled-components';
import { colors, getFontSize, getFontWeight } from '../../../abstracts';
export const DrawerTitle = styled.h2.withConfig({
  componentId: "aui__sc-14kgruz-0"
})(["padding:22px 48px 13px 16px;margin:0;box-sizing:border-box;width:100%;flex:none;font-size:", ";font-weight:", ";line-height:130%;color:", ";"], getFontSize(2), getFontWeight('heavy'), colors.black);